import { render, staticRenderFns } from "./PagesDropdown.vue?vue&type=template&id=f2e4957a&"
import script from "./PagesDropdown.vue?vue&type=script&lang=js&"
export * from "./PagesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PagesDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports